module.exports = __webpack_public_path__ + "img/new_index_service_icon1.25396c6c.png";